// extracted by mini-css-extract-plugin
export default {"productDescription":"t_-z","featuredDescription":"u_-z","description":"v_-z","more":"w_-z","descriptionSku":"x_-z"};